// Canonical Manpower Norms upload-template columns (used by the sample template
// download in ManpowerNormUploadModal).
//
// The backend parser (prx_project_management_service
// src/utils/helper.util.ts parseManpowerNormsFileToJson) locates the header row
// by the 'Item Code' cell and maps columns BY HEADER TEXT. Unlike the material
// norms sheet, manpower is FLAT — every row is a standalone manpower type, there
// is NO forward-fill. The master EXPORT is built server-side in the same format
// (manpower-norms/helpers/manpower-norms-export.helper.ts) — any header change
// must stay in sync across all three places.

export const MANPOWER_TEMPLATE_HEADERS = [
  "Item Code",
  "Item Description",
  "Units",
  "PUC Factor",
  "Unit Price",
];

export const MANPOWER_TEMPLATE_COL_WIDTHS = [
  { wch: 16 },
  { wch: 40 },
  { wch: 14 },
  { wch: 12 },
  { wch: 14 },
];
